<template>
    <div>
        <HeaderSection icon="fas fa-key" title="Perfil/Permiso">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/administracion')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <span>
            <el-row :gutter="24">
                <el-col :span="24">
                    <el-select v-model="profileId" placeholder="Selecciona un perfil" filterable
                               @change="getPermissions()">
                            <el-option
                                v-for="item in profiles"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <br>
            <el-row :gutter="24">
                <div class="tip">
                        Distribución predefinida de permisos para cada perfil
                </div>
                <el-col :span="8" v-for="permission in permissions" :key="permission.id">
                    <el-card style="margin-bottom: 2%">
                        <el-tree
                            :data="permission.data"
                            :props="defaultProps"
                            ref="tree"
                            node-key="id"
                            show-checkbox>
                        </el-tree>
                    </el-card>
                </el-col>
            </el-row>
            <el-row>
                <div align="right" v-if="permissions.length > 0">
                    <el-button @click="restartForm">Cancelar</el-button>
                    <el-button type="primary" @click="submitPermissionsBy()">Actualizar</el-button>
                </div>
            </el-row>
        </span>
    </div>
</template>

<script>
    import HeaderSection from '@/components/partials/HeaderSection'

    export default {
        components: {
            HeaderSection
        },
        data() {
            return {
                permissions: [],
                profiles: [],
                profileId: null,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                }
            }
        },

        created() {
            axios.get('/api/get-profiles').then(response => {
                if (response.data.success) {
                    this.profiles = response.data.profiles
                }
            }).catch(error => {
                console.log('created', error);

                this.$notify({
                    type: 'error',
                    message: 'No se pudo completar la acción'
                });
            });
        },

        methods: {
            restartForm() {
                this.permissions = [];
                this.profileId = null;
            },
            getPermissions() {
                this.permissions = [];
                axios.get('/api/get-permission',{params: {cat_profile_id: this.profileId}}).then(response => {
                    if (response.data.success) {
                        this.distributeRoles(response.data.roles, this.isInteger(response.data.roles));
                        if (response.data.distribution && response.data.distribution.length > 0) {
                            this.$nextTick(function () {
                                for (let i = 0; i < this.$refs.tree.length; i++) {
                                    this.$refs.tree[i].setCheckedKeys(response.data.distribution);
                                }
                            });
                        }

                    }
                }).catch(error => {
                    console.log('getPermissions', error);

                    this.$notify({
                        type: 'error',
                        message: 'No se pudo completar la acción'
                    });
                });
            },

            distributeRoles(roles, modules) {
                for (let i = 0; i < modules.length; i++) {
                    let tree = [];

                    _.forEach(roles, function (rol) {
                        if (rol.level === modules[i]) {
                            tree.push({
                                id: rol.id,
                                label: rol.description,
                                children: [],
                            });
                        }

                        if (rol.level > modules[i] && rol.level < modules[i] + 1) {
                            tree[0].children.push({
                                id: rol.id,
                                label: rol.description,
                            });
                        }
                    });
                    this.permissions.push({data: tree});
                }
            },

            isInteger(roles) {

                let modules = [];

                _.forEach(roles, function (rol) {
                    if (rol.level % 1 === 0) {
                        modules.push(rol.level);
                    }
                });
                return modules;
            },

            submitPermissionsBy() {
                let permissions = [];
                let distribution = [];

                if (this.$refs.tree.length > 0) {
                    for (let i = 0; i < this.$refs.tree.length; i++) {
                        if (this.$refs.tree[i].getCheckedKeys()) {
                            permissions.push(this.$refs.tree[i].getCheckedKeys());
                        }
                        distribution = permissions.concat();
                    }
                }
                distribution = [].concat.apply([], permissions);

                let data = {
                    cat_profile_id: this.profileId,
                    permissions: distribution
                };
                axios.post('/api/submit-profile-permissions', data).then((response) => {
                    this.$store.dispatch('loading/spinner', {}, {root: true});
                    const parsedResponse = response.data;
                    if (parsedResponse && parsedResponse.success) {
                        this.$message({
                            message: parsedResponse.message,
                            type: 'success'
                        });

                    }

                })
                    .catch((err) => {
                        this.$store.dispatch('loading/spinner', {}, {root: true});
                        let msg = 'No se pudo completar la acción';
                        this.$message.error('Oops,' + msg);
                    });

            }
        }


    }
</script>

<style scoped>

</style>
